const faqs = [
  {
    q: '91影视看片app完全免费吗？有没有隐藏收费？',
    a: '是的，91影视看片app坚持完全免费模式。无需注册会员、无需充值付费，所有影视资源均可免费在线观看。我们通过合理的广告策略维持运营，但绝不会设置强制弹窗或诱导付费等套路。',
  },
  {
    q: '91影视看片app支持哪些手机系统？',
    a: '91影视看片app同时支持安卓（Android 6.0及以上）和苹果iOS（iOS 13及以上）系统。兼容市面上绝大多数主流手机型号，包括华为、小米、OPPO、vivo、三星、iPhone等品牌设备。',
  },
  {
    q: '播放视频卡顿怎么办？如何调整清晰度？',
    a: '视频卡顿通常与网络环境有关。您可以在播放页面手动切换清晰度（流畅/高清/超清/4K），选择适合当前网速的画质。建议在Wi-Fi环境下选择高清或超清获得最佳体验，移动网络下可选择流畅模式。',
  },
  {
    q: '可以离线下载视频吗？下载的视频存在哪里？',
    a: '完全可以。在视频详情页点击"下载"按钮即可将影片缓存到本地。下载的视频存储在手机内部存储的指定文件夹中，您可以在app内"我的下载"中管理已缓存的影片，支持删除和查看存储空间。',
  },
  {
    q: '91影视看片app安全吗？会不会有病毒？',
    a: '请放心，91影视看片app安装包经过多家安全检测平台的严格审核，不含任何恶意代码、病毒或隐私窃取程序。建议用户从本页面提供的官方渠道下载安装包，避免从第三方非正规渠道下载以确保安全。',
  },
  {
    q: '如何更新到91影视看片app的最新版本？',
    a: '当有新版本发布时，打开app后会收到更新提示，点击即可自动下载并安装最新版本。您也可以随时返回本下载页面，手动下载最新版本的安装包进行覆盖安装。更新不会影响您的观看记录和已下载内容。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">关于91影视看片app的常见疑问，这里都有答案</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6"
            >
              <div className="flex items-start gap-3">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0 mt-0.5">
                  <span className="text-xs font-bold">Q</span>
                </div>
                <div>
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2">{faq.q}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}